export const validateMap = ({ step, status }) => {
  if (!step?.arguments?.code) {
    return { status, id: 'go-to-code', message: 'Add code' };
  }

  return { status: 'valid' };
};
